import { render, staticRenderFns } from "./claimActionsPanel.vue?vue&type=template&id=00d08035&scoped=true"
import script from "./claimActionsPanel.vue?vue&type=script&lang=js"
export * from "./claimActionsPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d08035",
  null
  
)

export default component.exports